import { render, staticRenderFns } from "./PdfFooter.vue?vue&type=template&id=7e8edda3&scoped=true&"
import script from "./PdfFooter.vue?vue&type=script&lang=js&"
export * from "./PdfFooter.vue?vue&type=script&lang=js&"
import style0 from "./PdfFooter.vue?vue&type=style&index=0&id=7e8edda3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8edda3",
  null
  
)

export default component.exports